var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_vm._v("\n        "+_vm._s(_vm.__('page_not_found.header'))+"\n    ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }